import {RouteDefinition} from '../../../routes';
import {DoorBrandListScreen} from './DoorBrandListScreen';
import {DoorBrandEditScreen} from './DoorBrandEditScreen';

export const DoorBrandSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/developer/door-brand',
        component: DoorBrandListScreen,
    },
    {
        routerLink: '/developer/door-brand/edit/:id',
        component: DoorBrandEditScreen,
    },
    {
        routerLink: '/developer/door-brand/edit',
        component: DoorBrandEditScreen,
    },
];
